<script setup>
const config = useRuntimeConfig();
const pixelId = config.public.metaPixelId;
const testCode = config.public.metaTestCode;

onMounted(() => {
  if (window.fbq) {
    // 1. Initialize WITHOUT automatic PageView
    // The third parameter {} is for advanced matching (email, etc.)
    window.fbq('init', pixelId);

    // 2. Manually send PageView with Test Code
    // PageView doesn't take custom data, so the 3rd arg is empty {}
    window.fbq('track', 'PageView', {}, {
      test_event_code: testCode
    });
    console.trace(`Pixel Id ${pixelId} initialized with test code ${testCode}`)
  }
});
</script>

<template>
  <NuxtLayout> <NuxtPage :key="$route.fullPath"/> </NuxtLayout>
  <ToastContainer />
</template>